export default __webpack_public_path__ + "static/media/2.c8e319c2.png";